module.exports = __webpack_public_path__ + "Contribution Template.xlsx";